// extracted by mini-css-extract-plugin
export default {"main":"Welcome_main__V0VgG","btn":"Welcome_btn__ZqyLS"};